import { Routes } from '@angular/router';

import { CanActivatAuthGuard } from './shared/auth/can-activate-guard.service';
import { RolesEnum } from './shared/enums/roles.enum';
import { NavigationTypeEnum } from './shared/enums/navigation-type.enum';

export const APP_ROUTES: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./back-office/components/admin-back-office.routing').then(m => m.AdminBackOfficeRoutingModule)
  },
  {
    path: 'shop/:channelName',
    loadChildren: () => import('./shop/shop.routing').then(m => m.SHOP_ROUTES)
  },
  {
    path: 'registration',
    loadChildren: () => import('./shared/components/registration/registration-routing.module').then(m => m.RegistrationRoutingModule),
    data: { navigationType: NavigationTypeEnum.newUser },
    canActivate: [CanActivatAuthGuard]
  },
  {
    path: 'tenants',
    loadChildren: () => import('./shared/components/tenants/tenants-routing.module').then(m => m.TenantsRoutingModule),
    canActivate: [CanActivatAuthGuard]
  },
  {
    path: 'welcome',
    loadChildren: () => import('./shared/components/welcome/welcome-routing.module').then(m => m.WelcomeRoutingModule),
    data: { navigationType: NavigationTypeEnum.newUser },
    canActivate: [CanActivatAuthGuard]
  },
  {
    path: 'errors/unauthorized',
    loadChildren: () => import('./back-office/shared/components/errors/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule),
    data: { navigationType: NavigationTypeEnum.error },
    canActivate: [CanActivatAuthGuard]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'shop/selectChannel'
  },
  {
    path: 'customer-detail/:id/customer-financial-summary/:reportId',
    loadChildren: () => import('./back-office/components/customer-financial-summary/customer-financial-summary.routing.module').then(m => m.CustomerFinancialSummaryRoutingModule),
    data: { navigationType: NavigationTypeEnum.backOffice, roles: [RolesEnum.Administrator, RolesEnum.StoreOwner, RolesEnum.StoreUser] },
    canActivate: [CanActivatAuthGuard]
  },
];
